export default {
  fetch(STORAGE_KEY){
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]')
  },
  save(STORAGE_KEY,items){
    window.localStorage.setItem(STORAGE_KEY,JSON.stringify(items))
  },
  delete(STORAGE_KEY){
    window.localStorage.removeItem(STORAGE_KEY)
  },
  isPoneAvailable(str) {
    var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
    if (!myreg.test(str)) {
      return false;
    } else {
      return true;
    }
  },
  setCookie(name,val){
    var exp = new Date();
    document.cookie=name+'='+escape(val)
  },
  getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
      return (arr[2]);
    else
      return null;
  },
  delCookie (name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.getCookie(name);
    if (cval != null)
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  },
  isMobile(){
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag;
  }


}




// WEBPACK FOOTER //
// ./src/assets/js/Global.js